export const MAX_SUGGESTIONS = 10
export const MAX_NAVIGATIONAL_SUGGESTIONS = 1
export const DEFAULT_SEARCH_DEPARTMENT = 'all_cards'
